var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoNetworkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-reactroot": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M3.94781 6.06913C2.72359 7.72845 2 9.77972 2 12C2 17.5228 6.47715 22 12 22C14.2203 22 16.2716 21.2764 17.9309 20.0522L3.94781 6.06913ZM20.0522 17.9309C21.2764 16.2716 22 14.2203 22 12C22 6.47715 17.5228 2 12 2C9.77972 2 7.72845 2.72359 6.06913 3.94781L20.0522 17.9309Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    undefined: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M8.06558 10.1869C8.02251 10.7749 8 11.3809 8 12C8 17.5228 9.79086 22 12 22C13.4015 22 14.6347 20.198 15.349 17.4703L8.06558 10.1869ZM15.9344 13.8131C15.9775 13.2251 16 12.6191 16 12C16 6.47715 14.2091 2 12 2C10.5985 2 9.36534 3.80195 8.65101 6.52969L15.9344 13.8131Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    undefined: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    stroke: "currentColor",
    d: "M12 22C14.2091 22 16 17.5228 16 12C16 6.47715 14.2091 2 12 2C9.79086 2 8 6.47715 8 12C8 17.5228 9.79086 22 12 22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    stroke: "currentColor",
    d: "M21.54 15H2.46002"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    stroke: "currentColor",
    d: "M2.46002 9H21.54"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1.46967 1.46967C1.76256 1.17678 2.23744 1.17678 2.53033 1.46967L22.5303 21.4697C22.8232 21.7626 22.8232 22.2374 22.5303 22.5303C22.2374 22.8232 21.7626 22.8232 21.4697 22.5303L1.46967 2.53033C1.17678 2.23744 1.17678 1.76256 1.46967 1.46967Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    undefined: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNetworkIcon);
export default __webpack_public_path__ + "static/media/NoNetworkIcon.774e82ec1ce8f13c89e6321f39cdf292.svg";
export { ForwardRef as ReactComponent };